export default "__VITE_ASSET__B$2it2lr__"